"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CarouselItem = exports.CarouselCard = void 0;

var _ = require("../..");

var _react = _interopRequireWildcard(require("react"));

var _reactUseMeasure = _interopRequireDefault(require("react-use-measure"));

var _resizeObserver = require("@juggle/resize-observer");

var _bind = _interopRequireDefault(require("classnames/bind"));

var _mobxReact = require("mobx-react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

require("./Carousel.css");

var _styles = {
  "carousel-item": "Carousel__carousel-item___30hMG",
  "carousel": "Carousel__carousel___ZQXjg",
  "right-arrow": "Carousel__right-arrow___3-2JE",
  "left-arrow": "Carousel__left-arrow___GHH4D",
  "external-arrows": "Carousel__external-arrows___1LzUb",
  "items-wall": "Carousel__items-wall___3M5cP",
  "items": "Carousel__items___kAVzz",
  "item": "Carousel__item___360r0"
};

const styles = _bind.default.bind(_styles);

const CarouselItem = (0, _mobxReact.observer)(({
  className,
  dataTestId,
  children,
  ...props
}) => {
  const composed_classname = (0, _bind.default)(styles('carousel-item'), className);
  return _react.default.createElement("div", {
    "data-testid": dataTestId,
    className: composed_classname,
    ...props
  }, children);
});
exports.CarouselItem = CarouselItem;
const CarouselCard = (0, _mobxReact.observer)(({
  className,
  dataTestId,
  children,
  padding,
  onClick,
  ...props
}) => {
  const composed_classname = (0, _bind.default)(styles('carousel-item'), className);
  return _react.default.createElement(_.Card, {
    noMargin: true,
    dataTestId: dataTestId,
    className: composed_classname,
    onClick: onClick,
    ...props
  }, _react.default.createElement(_.Content, {
    paddingLeftRight: padding,
    paddingTopBottom: padding
  }, children));
});
exports.CarouselCard = CarouselCard;
const INTERNAL_ARROWS_TOTAL_WIDTH = 48;
const Carousel = (0, _mobxReact.observer)(({
  className,
  dataTestId,
  children,
  gap = 0,
  arrowsExternal = false,
  visibleItems = 1,
  onStepChanged,
  showButtons = false,
  onCompleteButtonClick,
  ...props
}) => {
  const composed_classname = (0, _bind.default)(styles('carousel', {
    'external-arrows': arrowsExternal || showButtons
  }), className);
  const [measureRef, {
    width
  }] = (0, _reactUseMeasure.default)({
    polyfill: _resizeObserver.ResizeObserver
  });
  const [itemsHeightRef, {
    height: itemsHeight
  }] = (0, _reactUseMeasure.default)({
    polyfill: _resizeObserver.ResizeObserver
  });
  const [itemWidth, setItemWidth] = (0, _react.useState)(0);
  const [totalWidth, setTotalWidth] = (0, _react.useState)(0);
  const [currentStep, setCurrentStep] = (0, _react.useState)(0);
  const [leftPosition, setLeftPosition] = (0, _react.useState)(0);

  const totalItems = _react.default.Children.toArray(children).length;

  const currentStepRef = (0, _react.useRef)(currentStep);
  (0, _react.useEffect)(() => {
    if (width < 1) {
      return;
    }

    const arrowWidth = arrowsExternal || showButtons ? 0 : INTERNAL_ARROWS_TOTAL_WIDTH;
    let actualItemWidth = 0;

    if (visibleItems < 2) {
      actualItemWidth = width - arrowWidth;
    } else {
      const gaplessWidth = width - arrowWidth - (visibleItems - 1) * gap;
      actualItemWidth = gaplessWidth / visibleItems;
    }

    setItemWidth(actualItemWidth);
    setTotalWidth(actualItemWidth * totalItems + gap * (totalItems - 1));
  }, [width, gap, visibleItems, arrowsExternal, totalItems]);
  (0, _react.useEffect)(() => {
    const arrowWidth = arrowsExternal || showButtons ? 0 : INTERNAL_ARROWS_TOTAL_WIDTH;

    if (currentStep < 1) {
      setLeftPosition(0);
    } else if (currentStep >= totalItems - visibleItems) {
      setLeftPosition(totalWidth - width + arrowWidth);
    } else {
      setLeftPosition(itemWidth * currentStep + gap * currentStep);
    }

    if (onStepChanged && currentStepRef.current !== currentStep) {
      onStepChanged(currentStep, currentStepRef.current, totalItems);
    }

    currentStepRef.current = currentStep;
  }, [width, gap, currentStep, itemWidth, visibleItems, totalItems, totalWidth, arrowsExternal, onStepChanged]);

  const renderItem = (child, index) => {
    return _react.default.createElement("div", {
      key: index,
      "data-testid": dataTestId && `${dataTestId}-item-${index}`,
      className: styles('item'),
      style: {
        flexBasis: `${itemWidth}px`
      }
    }, child);
  };

  const items = _react.default.Children.toArray(children).filter(child => {
    if (_react.default.isValidElement(child) && (child.type === CarouselItem || child.type === CarouselCard)) {
      return true;
    }

    throw new Error(`Carousel only supports the 'Carousel.Item' or 'Carousel.Card' component`);
  });

  return _react.default.createElement("div", {
    "data-testid": dataTestId,
    "data-current-step": currentStep,
    className: composed_classname,
    ref: measureRef,
    ...props
  }, _react.default.createElement(_.Icon, {
    dataTestId: dataTestId && `${dataTestId}-left-arrow`,
    name: _.IconEnum.chevron_left,
    className: styles('left-arrow'),
    disabled: showButtons || currentStep < 1,
    onClick: () => {
      if (currentStep > 0) {
        setCurrentStep(currentStep - 1);
      }
    }
  }), _react.default.createElement("div", {
    className: styles('items-wall'),
    style: {
      height: `${itemsHeight}px`
    }
  }, _react.default.createElement("div", {
    className: styles('items'),
    ref: itemsHeightRef,
    style: {
      gap: `${gap}px`,
      transform: `translateX(-${leftPosition}px)`
    }
  }, items.map(renderItem))), _react.default.createElement(_.Icon, {
    dataTestId: dataTestId && `${dataTestId}-right-arrow`,
    name: _.IconEnum.chevron_right,
    disabled: showButtons || currentStep >= totalItems - visibleItems,
    className: styles('right-arrow'),
    onClick: () => {
      if (currentStep < totalItems - visibleItems) {
        setCurrentStep(currentStep + 1);
      }
    }
  }), showButtons && _react.default.createElement(_.CardFooter, {
    dataTestId: `${dataTestId}-footer`,
    primaryTestId: `${dataTestId}-footer-primary-button`,
    variant: currentStep === totalItems - visibleItems ? 'quaternary' : 'secondary',
    primaryCtaLabel: currentStep === totalItems - visibleItems ? 'Continue' : 'Next',
    primaryOnClick: () => {
      if (currentStep < totalItems - visibleItems) {
        setCurrentStep(currentStep + 1);
      }

      if (currentStep === totalItems - visibleItems && onCompleteButtonClick) {
        onCompleteButtonClick();
        setTimeout(() => setCurrentStep(0), 1000);
      }
    },
    secondaryCtaLabel: currentStep === 0 ? undefined : 'Back',
    secondaryOnClick: () => {
      if (currentStep > 0) {
        setCurrentStep(currentStep - 1);
      }
    }
  }));
});

var _default = Object.assign(Carousel, {
  Item: CarouselItem,
  Card: CarouselCard
});

exports.default = _default;